import {useWebPurchasesLookupQuery} from '~/store/rtkQuery';

interface LookupErrorProps {
  message: string;
  query: string;
}

/**
 * The error for a failed account lookup. A search that finds web purchases
 * but no account is expected, e.g. a gift buyer, so it shows as a note
 * rather than an error
 */
export const LookupError = ({message, query}: LookupErrorProps) => {
  // Shares the cache entry WebPurchases reads, so this adds no request.
  const {data, isLoading} = useWebPurchasesLookupQuery({query});

  if (isLoading) {
    return null;
  }

  if (data && !data.hasAccount && data.purchases.length > 0) {
    return (
      <div role="status" className="alert mt-4 max-w-md">
        <span>No account found. Showing web purchases for this email.</span>
      </div>
    );
  }

  return (
    <div role="alert" className="alert alert-error mt-4 max-w-md">
      <span>{message}</span>
    </div>
  );
};
